<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'security-roles'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <div class="d-flex align-items-center">
        <legend class="mb-0">Security Roles</legend>
        <button type="button" class="btn btn-info ms-auto mb-2" (click)="openActivityLog()">
          <i class="fa fa-history"></i>
          Activity Log
        </button>
      </div>
      <div class="form-group row">
        <label class="form-label col-sm-3 required" for="engagement-inspection-lead">Search Employee</label>
        <div class="col">
          <app-employee-search [employeeList]="employees"
            (onChange)="employeeChanged()"
            [(model)]="selectedEmployeeId"
            [errorMessage]="'Employee is invalid.'"
            (onSearch)="searchSpecificEmployee($event)">
          </app-employee-search>
        </div>
        <div class="col text-center mt-1">
          <input class="form-check-input"
            type="checkbox"
            [(ngModel)]="showCaptains"
            (change)="searchAllEmployees()"
            id="captain-checkbox"
            name="captain-checkbox">
            <label class="form-check-label" for="captain-checkbox">
              Captain
            </label>
          </div>
          <div class="col mt-1">
            <input class="form-check-input"
              type="checkbox"
              [(ngModel)]="showAdmins"
              (change)="searchAllEmployees()"
              id="admin-checkbox"
              name="admin-checkbox">
              <label class="form-check-label" for="admin-checkbox">
                Admin
              </label>
            </div>
          </div>
          @if (!!employeeSearchResults.length) {
            <div class="form-group row">
              <div class="col">
                <table class="table table-striped table-align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Name</th>
                      <th>User</th>
                      <th>Captain</th>
                      <th>Admin</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (!employeeSearchResults.length) {
                      <tr>
                        <td colspan="3">
                          <span class="d-block p-2">
                            <i class="fa fa-ban text-danger"></i>
                            No results&hellip;
                          </span>
                        </td>
                      </tr>
                    }
                    @for (employee of employeeSearchResults; track employee; let i = $index) {
                      <tr>
                        <td>
                          {{employee.id}}
                        </td>
                        <td>
                          {{employee.fullName}}
                        </td>
                        <td>
                          <label class="switch" title="Enable/Disable" style="margin-top: 10px">
                            <input type="checkbox"
                            [id]="'employee-' + employee.id + '-user'"
                            (change)="roleChanged(employee, 'user')"
                              [(ngModel)]="employee.canSignIn">
                              <span class="slider round"></span>
                            </label>
                          </td>
                          <td>
                            <label class="switch" title="Enable/Disable" style="margin-top: 10px">
                              <input type="checkbox"
                                [id]="'employee-' + employee.id + '-captain'"
                                (change)="roleChanged(employee, 'captain')"
                                [(ngModel)]="employee.isNationalQcAdmin">
                                <span class="slider round"></span>
                              </label>
                            </td>
                            <td>
                              <label class="switch" title="Enable/Disable" style="margin-top: 10px">
                                <input type="checkbox"
                                  [id]="'employee-' + employee.id + '-admin'"
                                  (change)="roleChanged(employee, 'admin')"
                                  [(ngModel)]="employee.isAdmin">
                                  <span class="slider round"></span>
                                </label>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                  </div>
                }
              </fieldset>
            </div>
          </div>

<ng-template #activityLogModal let-modal>
  <div class="modal-header">
    <h5 id="security-role-activity-log-title" class="modal-title">Security Role Activity Log</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    @if (isLoadingActivityLog) {
              <div class="d-flex align-items-center justify-content-center p-4">
                <span class="spinner-border spinner-border-sm mr-2" role="status"></span>
                Loading activity log&hellip;
              </div>
    } @else if (activityLogLoadError) {
              <div class="alert alert-danger mb-0">
                Unable to load the security role activity log.
              </div>
    } @else {
      <div class="d-flex align-items-center mb-2">
        <div ngbDropdown autoClose="outside" class="d-inline-block mr-2"
          [placement]="['bottom-left', 'bottom-right', 'top-left', 'top-right']"
          (openChange)="onActivityLogFilterOpen($event)" #activityFilterDropdown="ngbDropdown">
          <button type="button" class="btn btn-sm btn-secondary" id="security-activity-filter-toggle" ngbDropdownToggle>
            <i class="fa fa-filter"></i>
            Filter
          </button>
          <div ngbDropdownMenu aria-labelledby="security-activity-filter-toggle" class="p-3" style="min-width: 22rem;">
            <div class="mb-2">
              <label for="security-activity-changed-by-filter" class="form-label mb-1">User that made the change</label>
              <div class="d-flex">
                <input id="security-activity-changed-by-filter" type="text" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.changedBy" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear User" [disabled]="!draftActivityLogFilters.changedBy"
                  (click)="clearActivityLogFilter('changedBy')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="security-activity-person-filter" class="form-label mb-1">Person that was changed</label>
              <div class="d-flex">
                <input id="security-activity-person-filter" type="text" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.changedEmployee" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Person" [disabled]="!draftActivityLogFilters.changedEmployee"
                  (click)="clearActivityLogFilter('changedEmployee')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="security-activity-old-value-filter" class="form-label mb-1">Previous Role</label>
              <div class="d-flex">
                <select id="security-activity-old-value-filter" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.oldValue">
                  <option [ngValue]="null">All roles</option>
                  @for (role of activityLogRoleOptions; track role) {
                    <option [ngValue]="role">{{role}}</option>
                  }
                </select>
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Previous Role" [disabled]="!draftActivityLogFilters.oldValue"
                  (click)="clearActivityLogFilter('oldValue')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="security-activity-new-value-filter" class="form-label mb-1">Updated Role</label>
              <div class="d-flex">
                <select id="security-activity-new-value-filter" class="form-control form-control-sm"
                  [(ngModel)]="draftActivityLogFilters.newValue">
                  <option [ngValue]="null">All roles</option>
                  @for (role of activityLogRoleOptions; track role) {
                    <option [ngValue]="role">{{role}}</option>
                  }
                </select>
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Updated Role" [disabled]="!draftActivityLogFilters.newValue"
                  (click)="clearActivityLogFilter('newValue')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="security-activity-from-filter" class="form-label mb-1">Changed From (UTC)</label>
              <div class="d-flex">
                <input id="security-activity-from-filter" type="datetime-local" step="1"
                  class="form-control form-control-sm" [(ngModel)]="draftActivityLogFilters.changedFromUtc" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Changed From" [disabled]="!draftActivityLogFilters.changedFromUtc"
                  (click)="clearActivityLogFilter('changedFromUtc')">&times;</button>
              </div>
            </div>
            <div class="mb-2">
              <label for="security-activity-to-filter" class="form-label mb-1">Changed To (UTC)</label>
              <div class="d-flex">
                <input id="security-activity-to-filter" type="datetime-local" step="1"
                  class="form-control form-control-sm" [(ngModel)]="draftActivityLogFilters.changedToUtc" />
                <button type="button" class="btn btn-sm btn-outline-secondary ml-1"
                  title="Clear Changed To" [disabled]="!draftActivityLogFilters.changedToUtc"
                  (click)="clearActivityLogFilter('changedToUtc')">&times;</button>
              </div>
            </div>
            @if (activityLogDateFilterError) {
              <div class="text-danger small mb-2">{{activityLogDateFilterError}}</div>
            }
            <button type="button" class="btn btn-sm btn-primary"
              (click)="applyActivityLogFilters(activityFilterDropdown)">Apply</button>
          </div>
        </div>
        <button type="button" class="btn btn-sm btn-secondary"
          [disabled]="!hasActivityLogFilters"
          (click)="clearActivityLogFilters(activityFilterDropdown)">
          <i class="fa fa-times"></i>
          Clear All
        </button>
      </div>

      @if (!activityLog.length) {
        <div class="text-muted p-2">
          {{hasActivityLogFilters ? 'No security role activity matches the current filters.' : 'No security role activity has been recorded.'}}
        </div>
      } @else {
        <div class="table-responsive">
          <table class="table table-striped table-align-middle mb-0">
            <thead>
              <tr>
                <th>User that made the change</th>
                <th>Person that was changed</th>
                <th>Previous Role</th>
                <th>Updated Role</th>
                <th>Date/Time (UTC)</th>
              </tr>
            </thead>
            <tbody>
              @for (change of activityLog; track change) {
                <tr>
                  <td>{{change.changedByEmployeeName || change.changedByEmployeeId}}</td>
                  <td>{{change.changedEmployeeName || change.changedEmployeeId}}</td>
                  <td>{{getActivityLogValue(change.oldValue)}}</td>
                  <td>{{getActivityLogValue(change.newValue)}}</td>
                  <td>{{formatActivityLogDate(change.changedAtUtc)}}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  </div>
</ng-template>
